<template>
  <div class="page_channelClassification">
    <!-- <formTop @event2="changeDateType($event)" @fatherMethod="getList($event)" :listData="tableData" :pathname="pathnames"></formTop> -->
    <div class="hello">
      <div class="main-con">
        <div class="crumbs flex sb">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>报表</el-breadcrumb-item>
            <el-breadcrumb-item>招聘效能报表</el-breadcrumb-item>
            <!-- <el-breadcrumb-item>
              <span>客服报表</span>
              <span v-if="showDayOrWeekOronth==1">招聘渠道报表</span>
            </el-breadcrumb-item> -->
          </el-breadcrumb>
          <!-- <div class="flex">
            <div class="refeshTime" style="margin-right: 20px;">报表统计周期:2023/3/1~2023/3/31</div>
            <div class="refeshTime">生成时间：2023/4/1 01:00:02</div>
          </div> -->
        </div>
        <div class="empty_box">
          <el-empty description="暂未开放哦，敬请期待"></el-empty>
        </div>
        <!-- <div class="checkedgroup">
          <div class="checkboxTitle">实操业务类型：</div>
          <div class="checkedgroup2">
            <el-checkbox-group v-model="busCheckList" v-if="busTypeList.length>0" @change="handleCheckedChange">
              <el-checkbox v-for="(item,index) in busTypeList" :key="index" :label="item.strParametername"></el-checkbox>
            </el-checkbox-group>
          </div>
        </div>
        <div class="checkedgroup" v-if="activeName=='ProfitListRecrCounselor'">
          <span class="checkboxTitle">仅查看汇总：</span>
          <div class="checkedgroup2">
            <el-radio-group v-model="p_grouytype">
              <el-radio :label="1" @click.native.prevent="changeRadio(1)">上级机构汇总</el-radio>
              <el-radio :label="2" @click.native.prevent="changeRadio(2)">招聘团队汇总</el-radio>
              <el-radio :label="3" @click.native.prevent="changeRadio(3)">子部门汇总</el-radio>
              <el-radio :label="4" @click.native.prevent="changeRadio(4)">顾问汇总</el-radio>
              <el-radio :label="5" @click.native.prevent="changeRadio(5)">项目汇总</el-radio>
              <el-radio :label="6" @click.native.prevent="changeRadio(6)">区域汇总</el-radio>
              <el-radio :label="7" @click.native.prevent="changeRadio(7)">服务中心</el-radio>
              <el-radio :label="8" @click.native.prevent="changeRadio(8)">服务部门汇总</el-radio>
              <el-radio :label="9" @click.native.prevent="changeRadio(9)">客服汇总</el-radio>
            </el-radio-group>
          </div>
        </div>
        <div class="checkedgroup" v-if="activeName=='ProfitListRecrProjEffic'">
          <span class="flname">仅查看汇总：</span>
          <div class="checkedgroup2">
            <el-radio-group v-model="p_grouytype" @change="changeRadio">
              <el-radio :label="1" @click.native.prevent="changeRadio(1)">区域汇总</el-radio>
              <el-radio :label="2" @click.native.prevent="changeRadio(2)">服务中心汇总</el-radio>
              <el-radio :label="3" @click.native.prevent="changeRadio(3)">服务部门汇总</el-radio>
              <el-radio :label="4" @click.native.prevent="changeRadio(4)">客服汇总</el-radio>
              <el-radio :label="5" @click.native.prevent="changeRadio(5)">合伙人汇总</el-radio>
              <el-radio :label="6" @click.native.prevent="changeRadio(6)">业绩归属人汇总</el-radio>
              <el-radio :label="7" @click.native.prevent="changeRadio(7)">项目汇总</el-radio>
              <el-radio :label="8" @click.native.prevent="changeRadio(8)">业务类型汇总</el-radio>
            </el-radio-group>
          </div>
        </div>
        <div class="operationalReportsTable">
          <div class="ftabs">
            <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
              <el-tab-pane v-if="checkPermission(['channelClassification_tab_recruit'],permissionLists)" label="招聘顾问效能报表" name="ProfitListRecrCounselor">
              </el-tab-pane>
              <el-tab-pane v-if="checkPermission(['channelClassification_tab_project'],permissionLists)" label="招聘项目效能报表" name="ProfitListRecrProjEffic">
              </el-tab-pane>
              <el-tab-pane label="导出记录" name="expRecond"></el-tab-pane>
            </el-tabs>
          </div>
          <el-table :max-height="tableHeight - 320 > 350 ? tableHeight - 320 : 350" :data="tableData" v-loading="listLoading" border row-key="name" lazy :load="load" :tree-props="{children: 'children', hasChildren: 'hasChildren'}" element-loading-text="报表生成中..." element-loading-spinner="el-icon-loading" style="width: 99%" stripe @sort-change="handleSortChange">
            <template v-for="(item,index) in tableTitle">
              <el-table-column :key="index" :prop="item.StrColumId" :label="item.StrColumName" fit show-overflow-tooltip :width="item.StrColumName=='服务中心' ? '100px' : index == 0 && activeName == 'ProfitListRecrCounselor' ? '130px' : item.StrColumName.length>6 ? '128px' : item.StrColumName.length>4 ? '101px' : '90px'" sortable="custom">
              </el-table-column>
            </template>

          </el-table>
          <div class="block" v-if="totalcount>0" style="width:99%">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="listQuery.p_currpage" :page-size="listQuery.p_pageNum" :page-sizes="[10, 20, 50, 100, 200]" layout="total,sizes,prev,pager, next, jumper" :total="totalcount"></el-pagination>
          </div>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
  import xz from "@/common";
  import FormTop from "./components/formTop";
  import checkPermission from '@/utils/permission' // 权限判断函数
  import {
    parseTime
  } from '@/utils' //格式化时间格式
  export default {
    components: {
      FormTop,
      parseTime
    },
    data() {
      return {
        tableHeight: 0,
        listLoading: false,
        tabids: [],
        totalcount: 0,
        btnLoading: false,
        currentPage3: 1,
        tableData: [],
        p_grouytype: 0,
        tabName: '/channelClassification',
        old_tabName: '/channelClassification',
        orderArray: [],
        listQuery: {
          p_userid: Cookies.get("userid-b"),
          p_currpage: 1,
          p_pageNum: 10,
          p_lvl: 1, // 1按月，2按周，3按自选时间
          p_grouytype: 0,
          keyname: '',
          starttime: '',
          endttime: '',
          projectname: '', //项目名称
          strAchieveowner: '', //业绩归属人
          strpartner2: '', //合伙人
          businesstype: '', //业务
          strservuserid: '', //客服
          orderby: [], //排序
        },
        exportQuery: {
          perpage: 1000000,
          currpage: 1,
          strobjname: "", //简称
          strobjinstname: "", //业务立项部门
          strusername: "", //客服名称
          strprojecttype: '' //项目类别
        },
        activeName: 'ProfitListRecrCounselor',
        oldactiveName: 'ProfitListRecrCounselor',
        busTypeList: [], //业务类别列表
        sumTypeList: ['区域汇总', '服务中心汇总', '服务部门汇总', '客服汇总', '合伙人汇总', '业绩归属人汇总', '项目汇总', '业务类型汇总'],
        busCheckList: [],
        sumCheckList: [],
        tableTitle: [], //表头
        // 按钮权限参数
        butQuery: {
          path: '/channelClassification',
          powerEnName: 'reportForms'
        },
        permissionLists: [],
        pathnames: ''
      }
    },
    created() {
      this.calHeight();
      // this.getButtonPower()
      // this.getTreestr();
    },
    methods: {
      checkPermission,
      // 获取按钮权限
      getButtonPower() {
        xz.getbtnPowerIdBypage(this.butQuery).then(res => {
          // console.log('按钮',res)
          if (res.status == 'ok') {
            let resmsg = res.msg
            if (!this.isNull(resmsg)) {
              for (let index = 0; index < resmsg.length; index++) {
                let element = resmsg[index];
                this.permissionLists.push(element.Enname);
              }
              if (this.$route.query.activeName != undefined && this.$route.query.activeName) {
                this.activeName = this.$route.query.activeName;
                let data = {
                  name: this.$route.query.activeName
                }
                this.getTableTitle();
                this.handleClick(data)
              } else {
                if (this.checkPermission(['channelClassification_tab_recruit'], this.permissionLists)) {
                  this.activeName = 'ProfitListRecrCounselor'
                } else if ((!this.checkPermission(['channelClassification_tab_recruit'], this.permissionLists)) && (this.checkPermission(['channelClassification_tab_project'], this.permissionLists))) {
                  this.activeName = 'ProfitListRecrProjEffic'
                }
                this.getTableTitle();
              }

              // 判断是否有导出权限
              if (this.checkPermission(['channelClassification_export'], this.permissionLists)) {
                this.pathnames = 'recruit'
              } else {
                this.pathnames = 'norecruit'
              }
            } else {
              this.permissionLists = []
              this.activeName = ''
            }
          } else {
            this.permissionLists = []
            this.activeName = ''
          }
        })
      },
      calHeight() {
        this.tableHeight = Number(document.body.clientHeight);
        console.log('height', this.tableHeight)
      },
      //判断是否为空(包含0)
      isNull(o) {
        return o == undefined || o == "undefined" || (o + '').indexOf("undefined") > -1 || o == null || o == '' || o == 'null' || o == [] || o == 0 || o == 'NaN';
      },
      //导出
      exportHandle() {
        this.btnLoading = true;
        //reporttype ：员工统计    员工统计详情   渠道统计  渠道统计详情  渠道统计雇员
        // console.log("exportQuery", this.listQuery.strsrvcent,this.listQuery.strdatetype,this.listQuery.strdate,this.exportQuery);
        xz.reportCurrDataTable('员工统计详情', this.strsrvcent, this.listQuery.strdatetype, this.listQuery.strdate, this.exportQuery).then(res => {
          // console.log("reportCurrDataTable", res);
          if (res.status == 'ok') {
            this.btnLoading = false;
            this.$router.push({
              path: '/employee-exportRecordList',
              query: {
                custname: res.msg,
                isReport: true
              }
            })
          } else {
            this.btnLoading = false;
            this.$message({
              message: "导出错误",
              type: "error"
            })
          }
        });
      },
      //详情搜索
      onSearch() {

      },
      handleClick(tab) {
        if (tab.name == 'expRecond') {
          this.$router.push({
            path: '/effExportList',
            query: {
              type: 'channelClassification'
            }
          })
        } else if (this.oldactiveName == tab.name) {
          return
        } else {
          this.orderArray = [];
          this.listQuery.orderby = [];
          this.oldactiveName = tab.name;
          this.tableTitle = [];
          if (this.activeName == 'ProfitListRecrCounselor') {
            this.sumTypeList = ['渠道类型汇总', '渠道细分汇总', '项目汇总', '合伙人汇总', '业绩归属人汇总'];
            this.busCheckList = [];
            this.sumCheckList = [];
            this.listQuery.p_grouytype = 0;
            this.p_grouytype = 0
          } else if (this.activeName == 'ProfitListRecrProjEffic') {
            this.sumTypeList = ['区域汇总', '服务中心汇总', '服务部门汇总', '客服汇总', '合伙人汇总', '业绩归属人汇总', '项目汇总', '业务类型汇总']
            this.busCheckList = [];
            this.sumCheckList = [];
            this.listQuery.p_grouytype = 0;
            this.p_grouytype = 0
          }
          this.clear();
          this.getTableTitle();
          this.getTableDate();
        }
      },
      changeTabs(tab) {
        if (this.old_tabName == tab.name) {
          return
        } else {
          this.$router.push(tab.name)
        }
      },
      changeRadio(value) {
        this.p_grouytype = value === this.p_grouytype ? 0 : value;
        this.clear();
        this.listQuery.p_grouytype = this.p_grouytype;
        // if (this.activeName != 'ProfitListRecrCounselor' || this.p_grouytype == 5 || this.p_grouytype == 6) {
        //   this.getTableTitle();
        // }
        this.getTableTitle();
        this.getTableDate();
      },
      clear() {
        this.listQuery.p_currpage = 1;
        this.listQuery.projectname = '';
        this.listQuery.strAchieveowner = '';
        this.listQuery.strpartner2 = '';
        this.listQuery.businesstype = '';
        this.listQuery.strservuserid = ''
      },
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
        this.listQuery.p_currpage = 1;
        this.listQuery.p_pageNum = val;
        this.getTableDate();
      },
      handleCurrentChange(val) {
        this.listQuery.p_currpage = val
        console.log(`当前页: ${val}`, this.listQuery);
        this.getTableDate()
      },
      Summary() {},
      //获取业务类型
      getTreestr() {
        let data = {
          currpage: 1,
          perpage: 100,
          strIsDisable: "",
          keyword: ""
        }
        xz.getTreestr('JB_base_Busitype', data).then(res => {
          if (res.status == "ok") {
            this.busTypeList = res.msg.parent;
          } else {
            this.busTypeList = []
          }
        })
      },
      handleCheckedChange(val) {
        console.log(val)
        this.listQuery.businesstype = val.toString();
        this.getTableDate();
      },
      //获取表头
      getTableTitle() {
        let headData = {
          "currmon": ""
        }
        let activeName = this.activeName;
        if (this.activeName == 'ProfitListRecrCounselor') {
          if (this.listQuery.p_grouytype == 0) {
            activeName = this.activeName + 5
          } else if (this.p_grouytype > 4) {
            activeName = this.activeName + this.p_grouytype
          }
        } else {
          if (this.listQuery.p_grouytype == 0) {
            activeName = this.activeName + 7
          } else {
            activeName = this.activeName + this.p_grouytype
          }
        }

        xz.gettestreport('rtnreporthead', activeName, headData).then(res => {
          if (res.status == 'ok') {
            this.tableTitle = res.msg;
          } else {
            this.$message.error('系统出错')
            this.tableTitle = [];
          }
        })
      },
      //获取报表信息
      getTableDate() {
        this.listLoading = true;
        let activeName = this.activeName;
        if (this.activeName == 'ProfitListRecrCounselor') {
          if (this.p_grouytype > 4) {
            activeName = this.activeName + this.p_grouytype
          }
        } else {
          activeName = this.p_grouytype == 0 ? this.activeName + 7 : this.activeName + this.p_grouytype
        }
        xz.gettestreport('rtnreportdata', activeName, this.listQuery).then(res => {
          if (res.status == 'ok') {
            if (this.activeName == 'ProfitListRecrCounselor') {
              if (res.msg.length > 0) {
                res.msg.forEach((element, index) => {
                  this.$set(element, 'name', new Date().valueOf().toString() + (Math.random() * 1000).toString());
                  if (this.listQuery.p_grouytype > 4 || this.listQuery.p_grouytype == 0) {
                    this.$set(element, 'hasChildren', false)
                  } else {
                    this.$set(element, 'hasChildren', true)
                  }
                  if (index + 1 == res.msg.length) {
                    this.tableData = res.msg;
                  }
                })
              } else {
                this.tableData = [];
              }
            } else {
              this.tableData = res.msg;
            }
            if (res.msg.length > 0) {
              this.totalcount = res.msg[0].totalCount
            }
          } else {
            this.tableData = [];
            this.totalcount = 0
          }
          this.listLoading = false;
        })
      },
      load(tree, treeNode, resolve) {
        console.log('a', tree, treeNode)
        let keyname = '';
        switch (this.listQuery.p_grouytype) {
          case 1:
            keyname = treeNode.level === 0 ? 'organ-=-' + tree.organ : tree.level == 1 ? 'team-=-' + tree.team + ',organ-=-' + tree.organ : tree.level == 2 ? 'teamsub-=-' + tree.teamsub + ',team-=-' + tree.team + ',organ-=-' + tree.organ : 'Consultants-=-' + tree.Consultants;
            break;
          case 2:
            keyname = treeNode.level === 0 ? 'team-=-' + tree.team + ',organ-=-' + tree.organ : tree.level == 1 ? 'teamsub-=-' + tree.teamsub + ',team-=-' + tree.team + ',organ-=-' + tree.organ : 'Consultants-=-' + tree.Consultants;
            break;
          case 3:
            keyname = treeNode.level === 0 ? 'teamsub-=-' + tree.teamsub + ',team-=-' + tree.team + ',organ-=-' + tree.organ : 'Consultants-=-' + tree.Consultants;
            break;
          case 4:
            keyname = 'Consultants-=-' + tree.Consultants;
            break;
        }
        let data = {
          p_userid: Cookies.get("userid-b"),
          p_currpage: 1,
          p_pageNum: 1000,
          p_lvl: this.listQuery.p_lvl,
          p_grouytype: treeNode.level === 0 ? this.listQuery.p_grouytype + 1 : this.listQuery.p_grouytype + tree.level + 1,
          keyname: keyname,
          starttime: this.listQuery.starttime,
          endttime: this.listQuery.endttime,
          projectname: '', //项目名称
          strAchieveowner: '', //业绩归属人
          strpartner2: '', //合伙人
          businesstype: '', //业务
          strservuserid: '', //客服
          orderby: [], //排序
        }
        let activeName = this.activeName;
        xz.gettestreport('rtnreportdata', activeName, data).then(res => {
          if (res.status == 'ok' && res.msg.length > 0) {
            res.msg.forEach((element, index) => {
              this.$set(element, 'name', new Date().valueOf().toString() + (Math.random() * 1000).toString());
              this.$set(element, 'level', treeNode.level === 0 ? 1 : tree.level + 1)
              if (this.listQuery.p_grouytype > 3) {
                this.$set(element, 'hasChildren', false)
              } else if (treeNode.level === 0) {
                this.$set(element, 'hasChildren', true)
              } else if (!element.projectname) {
                this.$set(element, 'hasChildren', true)
              } else if (element.projectname) {
                this.$set(element, 'hasChildren', false)
              }
            })
            resolve(res.msg)
          } else {
            resolve([])
          }
        })

      },
      getList(data) {
        this.listQuery = data;
        this.listQuery.p_grouytype = this.p_grouytype;
        this.getTableDate()
        // let r = this.tabids.some(ele => ele.Strrolecont == 'RecrReport2')
        // if(r){
        //   this.getTableDate()
        // }
      },
      //排序
      handleSortChange({
        column,
        prop,
        order
      }) {
        this.orderArray = [];
        if (order) {
          //参与排序
          let flagIsHave = false;
          this.orderArray.forEach((element) => {
            if (element.prop === prop) {
              element.order = order;
              flagIsHave = true;
            }
          });
          if (!flagIsHave) {
            this.orderArray.push({
              prop: prop,
              order: order,
            });
          }
        } else {
          //不参与排序
          this.orderArray = this.orderArray.filter((element) => {
            return element.prop !== prop
          });
        }
        this.listQuery.orderby = this.orderArray;
        this.getTableDate();
        console.log('ff', this.orderArray)
      },
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.empty_box{
  display: flex;
  justify-content: center;
  margin-top: 50px;
}
  .ftabs {
    background: #fff;
    width: 99%;
  }

  .refeshTime {
    font-size: 14px;
    color: #909399;
    margin-right: 30px;
  }

  .checkedgroup {
    margin-bottom: 10px;
    display: flex;
    /* flex-flow: wrap; */
  }

  .checkboxTitle {
    white-space: nowrap;
    font-size: 14px;
  }
</style>
<style>
  .page_date_top .el-date-editor--daterange .el-input__icon {
    line-height: 26px;
  }

  .page_channelClassification .ftabs .el-tabs__header {
    margin: 0;
  }

  .checkedgroup .el-checkbox {
    margin-right: 10px;
  }

  .el-checkbox__label {
    padding-left: 3px;
  }

  .checkedgroup2 .el-checkbox {
    margin-bottom: 5px;
  }

  .checkedgroup2 .el-radio {
    /* margin-bottom: 5px; */
    margin-right: 10px;
    height: 23px;
    line-height: 23px;
  }

  .operationalReportsTable .el-table th.el-table__cell>.cell {
    padding-right: 0 !important;
  }

  .operationalReportsTable .el-table .sort-caret.descending {
    border-top-color: #19bd92
  }

  .operationalReportsTable .el-table .sort-caret.ascending {
    border-bottom-color: #19bd92
  }

  .operationalReportsTable .el-table .ascending .sort-caret.ascending {
    border-bottom-color: red;
  }

  .operationalReportsTable .el-table .descending .sort-caret.descending {
    border-top-color: red;
  }

  .page_channelClassification .el-radio:focus:not(.is-focus):not(:active):not(.is-disabled) .el-radio__inner {
    box-shadow: none;
  }
</style>